export const environment = {
  production: true,
  envName: 'prod',
  HOST: 'https://excel365addon.skyvia.com',
  AUTH_ENDPOINT: 'https://id.skyvia.com',
  API_ENDPOINT: 'https://app-api.skyvia.com',
  APP_ENDPOINT: 'https://app.skyvia.com',
};
